module.exports = __webpack_public_path__ + "img/11.590ab8a2.jpg";